const getId = () => Math.random().toString(16).slice(2);

const originals = [
  {
    title: 'The Quest: A Missão',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/423BEAB369D527CD1B0B6E08D2BE839E797682A3D23F2D8F5D0CDB4D3E1A563B/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Star Wars: Visions',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/2688CDEDF4AF9EA8E1ED15471E3136F519B8673C0AD196F6FCC27C813FD3F056/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Loki',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/5E077A9E5EEA839BE445CC5036FD8A2CFBF1BE7522E5FAB5BBCFA8BA5B775FC6/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Do Esboço à Realidade',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/EA52BD3EAF03796366D1E69104112FEC0F587881717E32AA120380C4F33AABA4/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'A Ursa Polar',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/65C9605FD3FA7978C61EBC9865901FF95C9E0BD061CFC42664933ECF278CF919/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Star Wars O Livro de Boba Fett',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/7708D5C08C229E7D47E38E6D4C97E84736C8D1ACA6D9715C81356367B4506E45/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Red - Crescer é uma Fera',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/1F9CEB2CEA3496D12135F968122F7C317624E3EF66894F2CBF3872A61ADCD32B/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'The Beatles: Get Back',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/09F09683307D496C1E6D74FD75E9F173B8979011BCB662CECC3E5AB0B5D0833D/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Gavião Arqueiro',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/6CC856BBBA7336D339C896F49D2315974D0C54DFE2909364FDC21ADA8479D21D/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'The Mandalorian',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/4F28D360C056300A14531F35E11848F0D8913DEE03DF553D9114E052FD060885/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Comidas Inimagináveis',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/F1002F85EC68AED02FD466C81693C588F6BB6CCF019AAE9AE7FDF185514FAC16/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Diary of a Wimpy Kid',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/78E447A4FAEEA1E96ACBF1645C2AE0533E97D604DBF48B491B5D62A5D7246B07/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'O Mundo Maravilhoso de Mickey Mouse',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/EF243996AFE364261F0C15E127BF01D97398AD1A66A1004D9915BFBDCFA7B775/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
];

export default originals;
